import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FDF5EA] to-white">
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-6 py-6 flex items-center justify-between">
          <Link
            to="/"
            className="font-serif text-2xl font-medium text-[#2D2D2D] hover:text-[#C9A96E] transition-colors"
          >
            봄날 AI 웨딩
          </Link>
          <span className="text-sm text-gray-500">개인정보처리방침</span>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white rounded-3xl shadow-lg p-8 md:p-12">
          <h1 className="font-serif text-3xl font-light text-[#2D2D2D] mb-2">
            개인정보처리방침
          </h1>
          <p className="text-sm text-gray-400 mb-10">시행일: 2025년 1월 1일</p>

          <div className="space-y-10 text-sm text-gray-700 leading-relaxed">
            <p>
              솔버스(이하 "회사")는 「개인정보 보호법」 등 관련 법령에 따라
              이용자의 개인정보를 보호하고, 이와 관련한 고충을 신속하고
              원활하게 처리하기 위하여 다음과 같은 개인정보처리방침을
              수립·공개합니다.
            </p>

            <section>
              <h2 className="text-lg font-medium text-[#2D2D2D] mb-3">
                제1조 (수집하는 개인정보 항목)
              </h2>
              <p className="mb-3">
                회사는 서비스 제공을 위해 다음의 개인정보를 수집합니다.
              </p>
              <div className="bg-gray-50 rounded-xl p-5 space-y-3">
                <div>
                  <p className="font-medium text-[#2D2D2D] mb-1">
                    1. 회원가입 시
                  </p>
                  <p className="text-gray-500">
                    필수: 이메일 주소, 비밀번호, 이름(닉네임)
                  </p>
                  <p className="text-gray-500">
                    선택: 프로필 사진
                  </p>
                  <p className="text-gray-500 mt-1">
                    카카오 소셜 로그인 시: 카카오 계정 이메일, 프로필 정보(닉네임, 프로필 이미지)
                  </p>
                </div>
                <div>
                  <p className="font-medium text-[#2D2D2D] mb-1">
                    2. 주문(결제) 시
                  </p>
                  <p className="text-gray-500">
                    필수: 이름, 연락처(휴대폰 번호), 이메일 주소
                  </p>
                </div>
                <div>
                  <p className="font-medium text-[#2D2D2D] mb-1">
                    3. 서비스 이용 과정에서 자동 수집
                  </p>
                  <p className="text-gray-500">
                    접속 IP, 쿠키, 서비스 이용 기록, 접속 로그, 기기 정보
                  </p>
                </div>
                <div>
                  <p className="font-medium text-[#2D2D2D] mb-1">
                    4. 사진 업로드 시
                  </p>
                  <p className="text-gray-500">
                    이용자가 업로드한 얼굴 사진 (AI 웨딩 사진 생성 목적)
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-lg font-medium text-[#2D2D2D] mb-3">
                제2조 (개인정보의 수집·이용 목적)
              </h2>
              <ol className="list-decimal list-inside space-y-1.5">
                <li>
                  <strong>서비스 제공:</strong> AI 웨딩 사진 생성, 주문 처리,
                  결과물 전달
                </li>
                <li>
                  <strong>회원 관리:</strong> 본인 확인, 부정 이용 방지, 고객
                  상담 및 문의 대응
                </li>
                <li>
                  <strong>결제 처리:</strong> 요금 결제, 환불 처리
                </li>
                <li>
                  <strong>서비스 개선:</strong> 서비스 이용 통계 분석, 신규
                  서비스 개발
                </li>
                <li>
                  <strong>법적 의무 이행:</strong> 전자상거래 등에서의 소비자
                  보호에 관한 법률 등 관련 법령에 따른 의무 이행
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-lg font-medium text-[#2D2D2D] mb-3">
                제3조 (개인정보의 보유 및 이용 기간)
              </h2>
              <p className="mb-3">
                회사는 원칙적으로 개인정보 수집·이용 목적이 달성된 후에는 해당
                정보를 지체 없이 파기합니다. 단, 관련 법령에 의해 보존할 필요가
                있는 경우 아래 기간 동안 보관합니다.
              </p>
              <div className="bg-gray-50 rounded-xl p-5 space-y-2">
                <div className="flex justify-between">
                  <span className="text-gray-500">계약 또는 청약철회 등에 관한 기록</span>
                  <span className="font-medium text-[#2D2D2D]">5년</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">대금결제 및 재화 등의 공급에 관한 기록</span>
                  <span className="font-medium text-[#2D2D2D]">5년</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">소비자의 불만 또는 분쟁처리에 관한 기록</span>
                  <span className="font-medium text-[#2D2D2D]">3년</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">접속 로그 기록</span>
                  <span className="font-medium text-[#2D2D2D]">3개월</span>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-lg font-medium text-[#2D2D2D] mb-3">
                제4조 (업로드 사진의 처리)
              </h2>
              <ol className="list-decimal list-inside space-y-1.5">
                <li>
                  이용자가 업로드한 사진은 AI 웨딩 사진 생성 목적으로만
                  사용됩니다.
                </li>
                <li>
                  업로드된 사진은 AI 이미지 생성 완료 후{" "}
                  <strong className="text-[#2D2D2D]">30일 이내</strong>에
                  서버에서 자동 삭제됩니다.
                </li>
                <li>
                  회사는 이용자의 사진을 AI 모델 학습, 마케팅 등 다른 목적으로
                  사용하지 않습니다.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-lg font-medium text-[#2D2D2D] mb-3">
                제5조 (개인정보의 제3자 제공)
              </h2>
              <p className="mb-2">
                회사는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다.
                다만, 아래의 경우는 예외로 합니다.
              </p>
              <ol className="list-decimal list-inside space-y-1.5">
                <li>이용자가 사전에 동의한 경우</li>
                <li>
                  법령의 규정에 의하거나, 수사 목적으로 법령에 정해진 절차와
                  방법에 따라 수사기관의 요구가 있는 경우
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-lg font-medium text-[#2D2D2D] mb-3">
                제6조 (개인정보 처리의 위탁)
              </h2>
              <p className="mb-3">
                회사는 서비스 제공을 위해 다음과 같이 개인정보 처리를
                위탁합니다.
              </p>
              <div className="bg-gray-50 rounded-xl p-5 space-y-2">
                <div className="flex justify-between">
                  <span className="text-gray-500">결제 처리</span>
                  <span className="font-medium text-[#2D2D2D]">
                    나이스페이먼츠(주)
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">클라우드 서버 운영</span>
                  <span className="font-medium text-[#2D2D2D]">
                    Amazon Web Services (AWS)
                  </span>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-lg font-medium text-[#2D2D2D] mb-3">
                제7조 (이용자의 권리·의무)
              </h2>
              <p className="mb-2">
                이용자는 언제든지 다음의 권리를 행사할 수 있습니다.
              </p>
              <ol className="list-decimal list-inside space-y-1.5">
                <li>개인정보 열람 요구</li>
                <li>개인정보 정정·삭제 요구</li>
                <li>개인정보 처리 정지 요구</li>
                <li>회원 탈퇴 (서비스 내 또는 이메일 요청)</li>
              </ol>
              <p className="mt-3">
                권리 행사는 서비스 내 마이페이지 또는 이메일(solvers.official@gmail.com)로
                요청하실 수 있으며, 회사는 지체 없이 조치합니다.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-medium text-[#2D2D2D] mb-3">
                제8조 (개인정보의 안전성 확보 조치)
              </h2>
              <p className="mb-2">
                회사는 개인정보의 안전성 확보를 위해 다음의 조치를 취합니다.
              </p>
              <ol className="list-decimal list-inside space-y-1.5">
                <li>개인정보의 암호화 (SSL/TLS 적용)</li>
                <li>해킹 등에 대비한 보안 시스템 운영</li>
                <li>개인정보 접근 권한 최소화</li>
                <li>개인정보 취급 직원 대상 정기 교육</li>
              </ol>
            </section>

            <section>
              <h2 className="text-lg font-medium text-[#2D2D2D] mb-3">
                제9조 (쿠키의 사용)
              </h2>
              <ol className="list-decimal list-inside space-y-1.5">
                <li>
                  회사는 이용자에게 맞춤형 서비스를 제공하기 위해 쿠키를
                  사용합니다.
                </li>
                <li>
                  이용자는 브라우저 설정을 통해 쿠키 저장을 거부할 수 있으며,
                  이 경우 일부 서비스 이용이 제한될 수 있습니다.
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-lg font-medium text-[#2D2D2D] mb-3">
                제10조 (개인정보 보호책임자)
              </h2>
              <div className="bg-gray-50 rounded-xl p-5 space-y-1.5">
                <p>
                  <span className="text-gray-500">성명:</span>{" "}
                  <span className="font-medium text-[#2D2D2D]">정홍기</span>
                </p>
                <p>
                  <span className="text-gray-500">직위:</span>{" "}
                  <span className="font-medium text-[#2D2D2D]">대표</span>
                </p>
                <p>
                  <span className="text-gray-500">이메일:</span>{" "}
                  <span className="font-medium text-[#2D2D2D]">
                    solvers.official@gmail.com
                  </span>
                </p>
                <p>
                  <span className="text-gray-500">전화번호:</span>{" "}
                  <span className="font-medium text-[#2D2D2D]">
                    010-2940-2884
                  </span>
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-lg font-medium text-[#2D2D2D] mb-3">
                제11조 (권익침해 구제방법)
              </h2>
              <p className="mb-3">
                개인정보 침해에 대한 피해 구제, 상담 등이 필요한 경우 아래
                기관에 문의하실 수 있습니다.
              </p>
              <div className="bg-gray-50 rounded-xl p-5 space-y-2">
                <p className="text-gray-500">
                  개인정보침해신고센터 (한국인터넷진흥원): 118
                </p>
                <p className="text-gray-500">
                  개인정보분쟁조정위원회: 1833-6972
                </p>
                <p className="text-gray-500">
                  대검찰청 사이버수사과: 1301
                </p>
                <p className="text-gray-500">
                  경찰청 사이버수사국: 182
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-lg font-medium text-[#2D2D2D] mb-3">
                제12조 (방침의 변경)
              </h2>
              <p>
                본 개인정보처리방침은 법령, 정책 또는 보안 기술의 변경에 따라
                내용의 추가·삭제·수정이 있을 수 있으며, 변경 시 서비스 내
                공지사항을 통해 고지합니다.
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
}
